module.exports = fox._r("images/promo/tutorial/15.png", __webpack_public_path__ + "_/common/images/promo/tutorial/15.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/15.png
// module id = 662
// module chunks = 2